import {signal} from '@angular/core';
import {ComponentMetadata} from '../../model/component-metadata.model';

export const landingSectionsSignal = signal<ComponentMetadata[]>([]);
